import _ from 'lodash';

import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';

import BuildingDescription from './building-description/building-description.component';

import BuildingAmenities from './building-amenities/building-amenities.component';

import BuildingLocation from './building-location/building-location.component';

import BuildingReviews from './building-reviews/building-reviews.component';

import BuildingDetailsCard from './building-details-card/building-details-card.component';

import BuildingHeader from './building-header/building-header.component';

import MediaGallery from '../media-gallery/media-gallery.component';

import FeaturedSpacesBuilding from '../featured-spaces/featured-spaces-building.component';

const BuildingDetails = (props) => {

    const { selectedBuilding, cities, allPortfolios, cmsData, selectedBuildingRoomTypes, selectedBuildingRoomTypesSummary } = props;

    const { isMounted } = useResponsive();
    
    const buildingImages = _.get(selectedBuilding, 'images');

    const cityId = _.get(selectedBuilding, 'address.cityId');

    const city = _.find(cities, { id: cityId });    

    return (
        <>
            <div className='container-root container-root-maxWidthLg'>

                <BuildingHeader 
                    city={city} 
                    selectedBuilding={selectedBuilding} 
                    selectedBuildingRoomTypes={selectedBuildingRoomTypes}
                />

                {isMounted && (
                    <MediaGallery 
                        allImages={buildingImages}
                    />
                )}

                <div className='main-grid-container'>

                    <div className='main-grid-item main-grid-sm-8 main-grid-xs-12'>

                        <div className='building-details-container'>

                            <BuildingDescription selectedBuilding={selectedBuilding} cities={cities} />
                            
                            <BuildingAmenities selectedBuilding={selectedBuilding} buildingContentCMS={cmsData} />
                            
                            <BuildingLocation selectedBuilding={selectedBuilding} buildingContentCMS={cmsData} />
                            
                            <BuildingReviews selectedBuilding={selectedBuilding} buildingContentCMS={cmsData} />

                        </div>

                    </div>

                    <div className='main-grid-item main-grid-sm-4 main-grid-xs-12'>
                        <BuildingDetailsCard 
                            selectedBuilding={selectedBuilding}
                            selectedBuildingRoomTypes={selectedBuildingRoomTypes}
                            cities={cities}
                            selectedBuildingRoomTypesSummary={selectedBuildingRoomTypesSummary}
                        />
                    </div>

                </div>

            </div>

            <FeaturedSpacesBuilding
                id="other-spaces-section"
                visibleRooms={6}
                text="Spaces"
                city={city}
                allPortfolios={allPortfolios}
                roomTypes={selectedBuildingRoomTypes}
                selectedBuilding={selectedBuilding}
            />

        </>
    );
};

export default BuildingDetails;

BuildingDetails.propTypes = {
    selectedBuilding: PropTypes.object,
    cities: PropTypes.object,
    allPortfolios: PropTypes.arrayOf(PropTypes.object),
    selectedBuildingRoomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    selectedBuildingRoomTypesSummary: PropTypes.array,
};


